import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { changeSeason } from 'common/store/modules/competition-nav/thunks';

export const SeasonNavItem = ({ seasons, removeFinals = false }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    if (!seasons.some((s) => s.id === Number(nav.season.id)) && seasons) {
        return '';
    }

    return (
        <div className="competition-nav__season-select">
            <Select
                items={seasons}
                itemToString={(season) => season.name}
                initialSelectedItem={
                    seasons && nav.season.id
                        ? seasons.find((s) => s.id === Number(nav.season.id))
                        : ''
                }
                activeItem={
                    seasons && nav.season.id
                        ? seasons.find((s) => s.id === Number(nav.season.id))
                        : ''
                }
                isReadyToRender={() => seasons?.length && Number(nav.season.id)}
                label={getTranslation('label.stats.season')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeSeason({
                            season: selectedItem,
                            removeFinals
                        })
                    );
                }}
            />
        </div>
    );
};

SeasonNavItem.propTypes = {
    seasons: PropTypes.array,
    removeFinals: PropTypes.bool
};
